import { jwtDecode } from "jwt-decode";

export type PlatformAuthPayload = {
  userType?: string;
  isSuperAdmin?: boolean;
  platformRole?: string | null;
  platformPermissions?: string[];
};

export function getPlatformAuth(): PlatformAuthPayload {
  const stored = localStorage.getItem("authUser");
  if (!stored) return {};
  try {
    const parsed = JSON.parse(stored);
    return jwtDecode<PlatformAuthPayload>(typeof parsed === "string" ? parsed : parsed?.token || stored);
  } catch {
    try {
      return jwtDecode<PlatformAuthPayload>(stored.replace(/^"|"$/g, ""));
    } catch {
      return {};
    }
  }
}

export function hasPlatformPermission(required?: string | string[]) {
  if (!required) return true;
  const auth = getPlatformAuth();
  if (String(auth.userType || "").toLowerCase() !== "admin") return false;
  if (auth.isSuperAdmin) return true;

  // Fail closed for legacy/stale admin sessions. Re-authentication refreshes
  // the token with current platform permissions.
  if (auth.platformPermissions === undefined) return false;
  const permissions = Array.isArray(auth.platformPermissions) ? auth.platformPermissions : [];
  const requiredPermissions = Array.isArray(required) ? required : [required];
  return requiredPermissions.some((permission) => permissions.includes(permission));
}
